export interface InteractionPolicy {
  isViewOnly: boolean;
  canMutateDiagram: boolean;
  canMutateStructure: boolean;
  canMutateStyles: boolean;
  canDragNodes: boolean;
  canDragBoards: boolean;
  canRearrangeParticipants: boolean;
  canPersistChanges: boolean;
}

export function createInteractionPolicy(isViewOnly: boolean): InteractionPolicy {
  if (!isViewOnly) {
    return {
      isViewOnly: false,
      canMutateDiagram: true,
      canMutateStructure: true,
      canMutateStyles: true,
      canDragNodes: true,
      canDragBoards: true,
      canRearrangeParticipants: true,
      canPersistChanges: true,
    };
  }
  return {
    isViewOnly: true,
    canMutateDiagram: false,
    canMutateStructure: false,
    canMutateStyles: false,
    canDragNodes: true,
    canDragBoards: true,
    canRearrangeParticipants: true,
    canPersistChanges: false,
  };
}
